module.exports = __webpack_public_path__ + "static/media/img.e0795b23.svg";